import { render, staticRenderFns } from "./Email List.vue?vue&type=template&id=46dad994&scoped=true&"
import script from "./Email List.vue?vue&type=script&lang=js&"
export * from "./Email List.vue?vue&type=script&lang=js&"
import style0 from "./Email List.vue?vue&type=style&index=0&id=46dad994&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dad994",
  null
  
)

export default component.exports